import Request from "../../../utils/Request"
import { AxiosResponse } from "axios"

/**
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 * @constructor
 */
const ChangeFunds = (data:any[] = false): Promise<AxiosResponse<T>> => {
	return Request.post("/advisors/individuals_ifa/change-funds", data);
}

/**
 * @returns {Promise<AxiosResponse<any>>}
 */
export default ChangeFunds
